module.exports = __webpack_public_path__ + "assets/chetong.5e65e3f29f5e46caa798109f74db8462.png";